import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined"
import DownloadIcon from "@mui/icons-material/Download"
import { MONO, CHAT_COLOR } from "../constants"
import { formatFileSize } from "../utils/chatFile"

function approxBytesFromDataUri(dataUri) {
  const commaIdx = dataUri.indexOf(",")
  if (commaIdx < 0) return 0
  return Math.round((dataUri.length - commaIdx - 1) * 0.75)
}

export function FileChip({ file, fileName, downloadable = true }) {
  if (!file || !fileName) return null
  return (
    <Box component={downloadable ? "a" : "div"} href={downloadable ? file : undefined} download={downloadable ? fileName : undefined}
      sx={{
        display: "flex", alignItems: "center", gap: 0.75, px: 1, py: 0.6, borderRadius: "8px",
        backgroundColor: "rgba(var(--app-fg-rgb),0.05)", border: "1px solid rgba(var(--app-fg-rgb),0.08)",
        textDecoration: "none", cursor: downloadable ? "pointer" : "default", maxWidth: 220,
        "&:hover": { borderColor: "rgba(245,158,11,0.3)", backgroundColor: "rgba(245,158,11,0.06)" },
      }}>
      <InsertDriveFileOutlinedIcon sx={{ fontSize: 20, color: CHAT_COLOR, flexShrink: 0 }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontFamily: MONO, fontSize: "0.66rem", color: "rgba(var(--app-fg-rgb),0.85)",
          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {fileName}
        </Typography>
        <Typography sx={{ fontFamily: MONO, fontSize: "0.56rem", color: "rgba(var(--app-fg-rgb),0.35)" }}>
          {formatFileSize(approxBytesFromDataUri(file))}
        </Typography>
      </Box>
      {downloadable && <DownloadIcon sx={{ fontSize: 14, color: "rgba(var(--app-fg-rgb),0.35)", flexShrink: 0 }} />}
    </Box>
  )
}

export default FileChip
